(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cozybead-kit-lightbox"] && !Shopify.designMode) return;
  try {
    (() => {
    const marker = '__cbKitLightbox';
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const distance = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
    const midpoint = (a, b) => ({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 });
    const cleanHistoryState = (value) => {
      if (!value || typeof value !== 'object') return value;
      const copy = { ...value };
      delete copy[marker];
      return copy;
    };

    function setup(dialog) {
      if (dialog.dataset.cbKitReady === 'true') return;
      const story = dialog.previousElementSibling;
      if (!story || !story.matches('.cb-carousel-story, .cb-project-story')) return;
      const triggers = [...story.querySelectorAll('a[data-cb-kit-lightbox]')];
      if (!triggers.length) return;
      dialog.dataset.cbKitReady = 'true';

      const items = triggers.map((anchor) => ({
        url: anchor.href,
        title: anchor.dataset.cbKitTitle || anchor.querySelector('[data-cb-kit-card-title]')?.textContent?.trim() || anchor.textContent.trim(),
        alt: anchor.querySelector('img')?.alt || anchor.textContent.trim()
      }));
      const labels = dialog.querySelector('[data-cb-kit-loading-text]').dataset;
      const title = dialog.querySelector('[data-cb-kit-title]');
      const count = dialog.querySelector('[data-cb-kit-count]');
      const stage = dialog.querySelector('[data-cb-kit-stage]');
      const image = dialog.querySelector('[data-cb-kit-image]');
      const loading = dialog.querySelector('[data-cb-kit-loading]');
      const status = dialog.querySelector('[data-cb-kit-status]');
      const fallback = dialog.querySelector('[data-cb-kit-fallback]');
      const save = dialog.querySelector('[data-cb-kit-save]');
      const close = dialog.querySelector('[data-cb-kit-close]');
      const prev = dialog.querySelector('[data-cb-kit-prev]');
      const next = dialog.querySelector('[data-cb-kit-next]');
      const zoomIn = dialog.querySelector('[data-cb-kit-in]');
      const zoomOut = dialog.querySelector('[data-cb-kit-out]');
      const fit = dialog.querySelector('[data-cb-kit-fit]');

      let index = 0;
      let scale = 1;
      let panX = 0;
      let panY = 0;
      let active = false;
      let closingRequested = false;
      let historyToken = '';
      let closeTimer = null;
      let loadToken = 0;
      let lastTrigger = null;
      let savedScrollY = 0;
      let savedBodyOverflow = '';
      let savedHtmlOverflow = '';
      const pointers = new Map();
      let gesture = null;

      function applyTransform() {
        const rect = stage.getBoundingClientRect();
        const naturalWidth = image.naturalWidth || rect.width;
        const naturalHeight = image.naturalHeight || rect.height;
        const ratio = Math.min(1, rect.width / naturalWidth, rect.height / naturalHeight);
        const baseWidth = naturalWidth * ratio;
        const baseHeight = naturalHeight * ratio;
        panX = clamp(panX, -Math.max(0, (baseWidth * scale - rect.width) / 2), Math.max(0, (baseWidth * scale - rect.width) / 2));
        panY = clamp(panY, -Math.max(0, (baseHeight * scale - rect.height) / 2), Math.max(0, (baseHeight * scale - rect.height) / 2));
        image.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + scale + ')';
      }

      function resetZoom() {
        scale = 1;
        panX = 0;
        panY = 0;
        pointers.clear();
        gesture = null;
        applyTransform();
      }

      function setScale(value) {
        scale = clamp(value, 1, 6);
        if (scale === 1) {
          panX = 0;
          panY = 0;
        }
        applyTransform();
      }

      function render(nextIndex) {
        index = (nextIndex + items.length) % items.length;
        const item = items[index];
        const token = ++loadToken;
        resetZoom();
        title.textContent = item.title;
        count.textContent = (index + 1) + ' / ' + items.length;
        image.alt = item.alt;
        loading.textContent = labels.cbKitLoadingText;
        status.textContent = labels.cbKitHelp;
        fallback.hidden = true;
        fallback.href = item.url;
        image.onload = () => {
          if (token !== loadToken || image.src !== item.url) return;
          loading.textContent = '';
          applyTransform();
        };
        image.onerror = () => {
          if (token !== loadToken || image.src !== item.url) return;
          loading.textContent = labels.cbKitLoadError;
        };
        image.src = item.url;
        if (image.complete && image.naturalWidth) {
          loading.textContent = '';
          applyTransform();
        }
      }

      function finalizeClose() {
        if (closeTimer !== null) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }
        if (!active) return;
        active = false;
        closingRequested = false;
        loadToken += 1;
        pointers.clear();
        gesture = null;
        if (dialog.open) dialog.close();
        document.body.style.overflow = savedBodyOverflow;
        document.documentElement.style.overflow = savedHtmlOverflow;
        image.removeAttribute('src');
        loading.textContent = '';
        status.textContent = labels.cbKitHelp;
        fallback.hidden = true;
        const trigger = lastTrigger;
        lastTrigger = null;
        requestAnimationFrame(() => {
          window.scrollTo(0, savedScrollY);
          if (trigger?.isConnected) trigger.focus({ preventScroll: true });
        });
      }

      function requestClose() {
        if (!active || closingRequested) return;
        if (history.state && history.state[marker] === historyToken) {
          closingRequested = true;
          const requestedToken = historyToken;
          history.back();
          closeTimer = window.setTimeout(() => {
            closeTimer = null;
            if (!active || historyToken !== requestedToken || !closingRequested) return;
            if (history.state && history.state[marker] === requestedToken) {
              history.replaceState(cleanHistoryState(history.state), '', location.href);
            }
            finalizeClose();
          }, 700);
        } else {
          finalizeClose();
        }
      }

      function open(itemIndex, trigger) {
        if (closeTimer !== null) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }
        if (active) {
          render(itemIndex);
          return;
        }
        lastTrigger = trigger;
        savedScrollY = window.scrollY;
        savedBodyOverflow = document.body.style.overflow;
        savedHtmlOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        active = true;
        historyToken = String(Date.now()) + '-' + Math.random().toString(36).slice(2);
        try {
          const state = history.state && typeof history.state === 'object' ? history.state : {};
          history.pushState({ ...state, [marker]: historyToken }, '', location.href);
        } catch (_) {
          historyToken = '';
        }
        render(itemIndex);
        close.focus({ preventScroll: true });
      }

      triggers.forEach((anchor, itemIndex) => {
        anchor.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          open(itemIndex, anchor);
        });
      });

      close.addEventListener('click', requestClose);
      prev.addEventListener('click', () => render(index - 1));
      next.addEventListener('click', () => render(index + 1));
      zoomIn.addEventListener('click', () => setScale(scale * 1.5));
      zoomOut.addEventListener('click', () => setScale(scale / 1.5));
      fit.addEventListener('click', resetZoom);
      stage.addEventListener('dblclick', (event) => {
        event.preventDefault();
        setScale(scale > 1 ? 1 : 2);
      });
      stage.addEventListener('wheel', (event) => {
        if (!event.ctrlKey && !event.metaKey) return;
        event.preventDefault();
        setScale(scale * (event.deltaY < 0 ? 1.2 : 1 / 1.2));
      }, { passive: false });

      stage.addEventListener('pointerdown', (event) => {
        if (!active || !image.naturalWidth) return;
        stage.setPointerCapture(event.pointerId);
        pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (pointers.size === 1) {
          gesture = {
            mode: scale > 1 ? 'pan' : 'swipe',
            startX: event.clientX,
            startY: event.clientY,
            startPanX: panX,
            startPanY: panY,
            pointerType: event.pointerType,
            hadMulti: false
          };
        } else if (pointers.size === 2) {
          const [a, b] = [...pointers.values()];
          gesture = {
            mode: 'pinch',
            startDistance: Math.max(1, distance(a, b)),
            startMid: midpoint(a, b),
            startScale: scale,
            startPanX: panX,
            startPanY: panY,
            hadMulti: true
          };
        }
      });

      stage.addEventListener('pointermove', (event) => {
        if (!pointers.has(event.pointerId)) return;
        pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (!gesture) return;
        if (pointers.size >= 2) {
          const [a, b] = [...pointers.values()];
          if (gesture.mode !== 'pinch') {
            gesture = {
              mode: 'pinch',
              startDistance: Math.max(1, distance(a, b)),
              startMid: midpoint(a, b),
              startScale: scale,
              startPanX: panX,
              startPanY: panY,
              hadMulti: true
            };
          }
          const currentMid = midpoint(a, b);
          scale = clamp(gesture.startScale * distance(a, b) / gesture.startDistance, 1, 6);
          const stageRect = stage.getBoundingClientRect();
          const centerX = stageRect.left + stageRect.width / 2;
          const centerY = stageRect.top + stageRect.height / 2;
          const factor = scale / gesture.startScale;
          panX = currentMid.x - centerX - (gesture.startMid.x - centerX - gesture.startPanX) * factor;
          panY = currentMid.y - centerY - (gesture.startMid.y - centerY - gesture.startPanY) * factor;
          applyTransform();
        } else if (gesture.mode === 'pan') {
          panX = gesture.startPanX + event.clientX - gesture.startX;
          panY = gesture.startPanY + event.clientY - gesture.startY;
          applyTransform();
        }
      });

      function endPointer(event, cancelled) {
        if (!pointers.has(event.pointerId)) return;
        const swipe = gesture && gesture.mode === 'swipe' && !gesture.hadMulti && !cancelled && gesture.pointerType === 'touch';
        const deltaX = event.clientX - (gesture?.startX || event.clientX);
        const deltaY = event.clientY - (gesture?.startY || event.clientY);
        pointers.delete(event.pointerId);
        if (pointers.size === 0) {
          gesture = null;
          if (swipe && Math.abs(deltaX) > 65 && Math.abs(deltaX) > Math.abs(deltaY) * 1.4) render(index + (deltaX < 0 ? 1 : -1));
        } else if (gesture?.hadMulti) {
          const point = [...pointers.values()][0];
          gesture = { mode: scale > 1 ? 'pan' : 'suppressed', startX: point.x, startY: point.y, startPanX: panX, startPanY: panY, hadMulti: true };
        }
      }

      stage.addEventListener('pointerup', (event) => endPointer(event, false));
      stage.addEventListener('pointercancel', (event) => {
        endPointer(event, true);
        if (pointers.size === 0) gesture = null;
      });
      stage.addEventListener('lostpointercapture', (event) => endPointer(event, true));

      save.addEventListener('click', async () => {
        const item = items[index];
        const capturedIndex = index;
        save.disabled = true;
        status.textContent = labels.cbKitSaveProgress;
        fallback.hidden = true;
        try {
          const response = await fetch(item.url, { mode: 'cors' });
          if (!response.ok) throw new Error('download failed');
          const blob = await response.blob();
          const objectUrl = URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          const filename = decodeURIComponent(new URL(item.url).pathname.split('/').pop() || 'cozybead-image.png');
          anchor.href = objectUrl;
          anchor.download = filename;
          anchor.style.display = 'none';
          document.body.appendChild(anchor);
          anchor.click();
          anchor.remove();
          window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
          if (active && index === capturedIndex) status.textContent = labels.cbKitSaveDone;
        } catch (_) {
          if (active && index === capturedIndex) {
            status.textContent = labels.cbKitSaveError;
            fallback.href = item.url;
            fallback.hidden = false;
          }
        } finally {
          save.disabled = false;
        }
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        requestClose();
      });
      dialog.addEventListener('close', finalizeClose);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) requestClose();
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          render(index - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          render(index + 1);
        }
      });
      window.addEventListener('popstate', (event) => {
        if (active) {
          finalizeClose();
        } else if (event.state && event.state[marker]) {
          history.replaceState(cleanHistoryState(event.state), '', location.href);
        }
      });
      window.addEventListener('resize', () => {
        if (active) applyTransform();
      });
    }

    const init = (root) => root.querySelectorAll('.cb-kit-lightbox').forEach(setup);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
